import React from "react";
import { Route } from "react-router-dom";
import AgentPs from "../components/AgentPs";
import InfoPs from "../components/InfoPs";
import CheckTask from "../components/Usuarios/CheckTask";
import Main from "../layout/Main";
import Profile from "../pages/Profile";
import Soporte from "../pages/Soporte";
import CalendarDaily from "../pages/User/CalendarDaily";
import EmotionsDiary from "../pages/User/EmotionsDiary";
import HistoryAppoitment from "../pages/User/HistoryAppoitment";
import Inicio from "../pages/User/Inicio";
import Note from "../pages/User/Note";
import Paid from "../pages/User/Paid";
import Profesionales from "../pages/User/Profesionales";
import ResultadosTest from "../pages/User/ResultadosTest";
import Tareas from "../pages/User/Tareas";
import Test from "../pages/User/Test";
import { UpTest } from "../pages/User/UpTest";
import routers from "../routes";
import PrivateRoute from "../utils/PrivateRoute";

const NavigationUsers = () => {
  return (
    <div>
      {" "}
      <Route exact path={routers}>
        <Main>
          <Route exact path="/" component={Inicio} />
          <Route exact path="/inicio" component={Inicio} />
          <Route exact path="/tareas" component={Tareas} />
          <Route exact path="/test" component={Test} />
          <Route exact path="/Profesionales" component={Profesionales} />
          <Route exact path="/history" component={HistoryAppoitment} />
          <Route exact path="/Soporte" component={Soporte} />
          <Route exact path="/profile" component={Profile} />
          <Route exact path="/informacion/:name" component={InfoPs} />
          <Route exact path="/agenda/:name" component={AgentPs} />
          <Route exact path="/check" component={CheckTask} />
          <Route exact path="/pagos" component={Paid} />
          <Route exact path="/diario" component={EmotionsDiary} />
          <Route exact path="/calendario-diario" component={CalendarDaily} />
          <Route exact path="/nota" component={Note} />
          <Route exact path="/resultados" component={ResultadosTest} />
        </Main>
      </Route>
    </div>
  );
};

export default NavigationUsers;
